<template>
  <div>
    <header class="wrapper-header">
      <div class="wrap-nav-products">
        <div class="wrap-icon-product">
          <t-icon class="icon-product" :icon="[ 'far', 'user' ]" />
        </div>
        <span class="name-product">Mala Direta</span>
      </div>

      <div v-if="!isLogin" class="wrap-nav-user">
        <sui-dropdown>
          <img :src="require('@/assets/images/avatar.jpg')" alt="" class="avatar-user">
          <sui-dropdown-menu>
            <sui-dropdown-item @click="logoutUser">Sair</sui-dropdown-item>
          </sui-dropdown-menu>
        </sui-dropdown>
      </div>
    </header>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  data() {
    return {
      isLogin: false
    }
  },

  mounted () {
    this.removeNav()
  },

  updated () {
    this.removeNav()
  },

  methods: {
    ...mapActions(['logout']),

    logoutUser () {
      this.logout()
        .then(resp => this.$router.push('/login'))
        .catch(err => this.$log.error('error', err))
      this.isLogin = false
    },

    removeNav () {
      const login = this.$route.name
      login === 'Login' ? this.isLogin = true : this.isLogin = false
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/css/colors.scss";

.wrapper-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 60px;
  padding: 0 15px;
  border-bottom: 1px solid $border-color;
  box-sizing: border-box;

  .wrap-nav-products {
    display: flex;
    align-items: center;

    .wrap-icon-product {
      height: 40px;
      width: 40px;
      background: $blue-500;
      border-radius: 3px;
      color: $white-100;
      font-size: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 10px;
    }

    .name-product {
      font-weight: 700;
      font-size: 12.8px;
      line-height: 18px;
    }
  }

  .wrap-nav-user .ui.dropdown {
    display: flex;
    align-items: center;
    flex-flow: row-reverse;
  }
}
</style>
